import { render, staticRenderFns } from "./BankStatementDetails.vue?vue&type=template&id=2aee65c2&scoped=true"
import script from "./BankStatementDetails.vue?vue&type=script&lang=js"
export * from "./BankStatementDetails.vue?vue&type=script&lang=js"
import style0 from "./BankStatementDetails.vue?vue&type=style&index=0&id=2aee65c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aee65c2",
  null
  
)

export default component.exports